// extracted by mini-css-extract-plugin
module.exports = {"cell":"Cell_cell__3-ueS constants_colors__2ZDH7","cell_with_content":"Cell_cell_with_content__veDHR Cell_cell__3-ueS constants_colors__2ZDH7","win_cell":"Cell_win_cell__3SK2w"};